<template>
  <div>
    <mt-header :title="title" class="navheader">
      <!-- <mt-button icon="back" slot="left" @click="$router.go(-1)" class="headerbtn"></mt-button>
      <div slot="right" @click='$router.push("/")'> <i class="iconfont icon-shouye"></i> </div> -->
      <div slot="right" @click='home'><img class="icon" src="../static/image/shouye.png" alt=""/></div>
    </mt-header>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    title: {
      type: String,
      default: '天安智慧云',
    },
    routePath: {
      type: String,
    },
  },
  methods: {
    back() {
      if (!this.routePath) {
        this.$router.go(-1);
      } else {
        const path = this.routePath === '/' ? '/index' : this.routePath;
        // this.$router.push(this.routePath);
        window.location.href = `${this.URL_PREFIX_PAGE}${path}`;
      }
    },
    home() {
      window.location.href = `${this.URL_PREFIX_PAGE}/index?parkId=${this.currentParkId}`;
    },
  },
  computed: {
    ...mapGetters(['currentParkId']),
  },
}
</script>

<style lang="scss" scoped>
.navheader{
  height: 1.173333rem;
  font-weight: bold;
  font-size: .453333rem;
  text-align: center;
  background-color: #fff;
  color: rgb(55, 55, 55);
  border-bottom: 1px solid rgb(246, 246, 246);
  .icon{
    width: .753333rem;
  }
}
.headerbtn{
  color: rgb(51, 51, 51);
}

</style>



// WEBPACK FOOTER //
// src/components/Navigator.vue